import Cookies from 'js-cookie';
import moment from 'moment';
import api from '@/api';
import { routerTo, get_tUser } from './util'

export const checkJWT = () => {
  return new Promise(async resolve => {
    let jwt = Cookies.get('_t')
    let jwtTime = Cookies.get('_t_at') && moment(Cookies.get('_t_at') * 1000).format('YYYYMMDDHHssmm')
    let jwtEndTime = moment().add(7, 'd').format('YYYYMMDDHHssmm')
    if (!jwt || !jwtTime) {
      resolve({ Authorization: '' })
    } else if (jwtTime < jwtEndTime) {
      let res = await api.jwt.refreshJwt({ jwt })
      if (res.code === 1000) {
        let { jwt, jwt_timestamp } = res.data
        await updateJWT({
          jwt,
          jwt_timestamp,
          cookieEndTime: moment().add(14, 'd').valueOf()
        })
        resolve({
          Authorization: jwt
        })
      } else {
        updateJWT({}, 'remove')
        resolve({
          Authorization: ''
        })
      }
    } else {
      resolve({
        Authorization: jwt
      })
    }
  })
}

export const updateJWT = (data, remove) => {
  let { hostname } = window.location
  let { jwt, jwt_timestamp, cookieEndTime } = data
  if (remove) {
    Cookies.remove('_t', {
      domain: `${hostname.split('.')[1]}.${hostname.split('.')[2]}`,
      path: '/',
    })
    Cookies.remove('_t_at', {
      domain: `${hostname.split('.')[1]}.${hostname.split('.')[2]}`,
      path: '/',
    })
    Cookies.remove('_t_plugin', {
      domain: `${hostname.split('.')[1]}.${hostname.split('.')[2]}`,
      path: '/',
    })
    Cookies.remove('_t_plugin_at', {
      domain: `${hostname.split('.')[1]}.${hostname.split('.')[2]}`,
      path: '/',
    })
  } else {
    Cookies.set('_t', jwt, {
      domain: `${hostname.split('.')[1]}.${hostname.split('.')[2]}`,
      path: '/',
      expires: cookieEndTime
    })
    Cookies.set('_t_at', jwt_timestamp, {
      domain: `${hostname.split('.')[1]}.${hostname.split('.')[2]}`,
      path: '/',
      expires: cookieEndTime
    })
  }
}

// 生成浏览器登录指纹
export const getEquipmentNumberFn = () => {

  const bin2hex = (s) => {
    var i,l,o = "",n;s += "";
    for (i = 0, l = s.length; i < l; i++) {
      n = s.charCodeAt(i).toString(16);
      o += n.length < 2 ? "0" + n : n;
    }
    return o;
  }

  const getUUID = (domain) => {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    var txt = domain;
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = "tencent";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);

    var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
    // window.atob 用于解码使用 base-64 编码的字符串
    var bin = atob(b64);
    var crc = bin2hex(bin.slice(-16, -12));
    return crc;
  }

  return getUUID("wondercv")
}

export const verifyTrustDevice = async () => {
  try {
    if (!Cookies.get('_t')) return 'not login';
    
    const res = await api.account.getCip();
    if (res.code === 1000 && res.data.internal) return '内网环境';
    
    const { code, data } = await api.account.getDeviceList();
    if (code === 1000) {
      const { devices = [] } = data;

      if (!devices.length) return console.log('导师辅导账号');

      const device_number = (navigator.appName + navigator.platform + navigator.product + navigator.userAgent).replace(/\//g,"") + getEquipmentNumberFn();
      const index = devices.findIndex(item => item.device_number === device_number);

      if (index === -1) {
        const hostname = window.location.hostname;
        let domain = hostname.replace(/.*?(\.wondercv.(cn|com))/gim, '$1');
        Cookies.remove('_t', { domain });
        Cookies.remove('_t_plugin', { domain });

        routerTo('/auth-signin/?type=login');
      }
    }
  } catch (error) {
    console.log(error)
  }
}

export const checkUserMatch = async () => {
  try {
    if (window.location.href.includes('ai/onboarding')) return;
    if (!Cookies.get('_t')) return 'not login';
    const token = await get_tUser()?.c_t;
    if (!token) return 'not login';
    const res = await api.me.getUserInfo(token);
    if (!res.data.match) {
      routerTo('/ai/onboarding');
    }
  } catch (error) {
    console.log(error)
  }
}
